import * as React from 'react';

import { useRdPageLockStatus } from '@neo.tax/rd/hooks';
import { PageLayout, type PageLayoutProps } from '@neo.tax/shared';

export const RdLockPageLayout: React.FC<
  Omit<PageLayoutProps, 'locked' | 'lockedReason'> & {
    forceUnlock?: boolean;
    disableIfOngoingSync?: boolean;
    disableIfProjectDetailsUpdateInProgress?: boolean;
    disableIfRdCostPendingValidation?: boolean;
    disableIfRdProjectsImportInProgress?: boolean;
    disableIfSupervisorAllocationInProgress?: boolean;
  }
> = ({
  children,
  disableIfOngoingSync,
  disableIfProjectDetailsUpdateInProgress,
  disableIfRdCostPendingValidation,
  disableIfRdProjectsImportInProgress,
  disableIfSupervisorAllocationInProgress,
  forceUnlock,
  lockButtons,
  ...rest
}) => {
  const { pageLockStatus } = useRdPageLockStatus({
    disableIfOngoingSync,
    disableIfProjectDetailsUpdateInProgress,
    disableIfRdCostPendingValidation,
    disableIfRdProjectsImportInProgress,
    disableIfSupervisorAllocationInProgress,
  });

  return (
    <PageLayout
      locked={forceUnlock ? false : pageLockStatus.locked}
      lockButtons={
        forceUnlock ? (
          []
        ) : (
          <>
            {pageLockStatus.lockButtons}
            {lockButtons}
          </>
        )
      }
      lockedReason={forceUnlock ? '' : pageLockStatus.lockedReason}
      {...rest}
    >
      {children}
    </PageLayout>
  );
};
